import { useSelector } from 'react-redux';
import moment from 'moment';
import { Box, Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import ProgressIcon from 'assets/icons/Progress.svg?react';
import MemberCodeStatusStepper from 'views/MemberZoneAccess/MemberZoneStatus/MemberCodeStatusStepper';
import { selectMemberCodeDetails } from 'selectors/memberCodeSelector';

export const MemberZoneStatus = () => {
  const memberCodeDetails = useSelector(selectMemberCodeDetails);

  return (
    <Card style={{ maxWidth: '90%' }} square>
      <Grid container style={{ paddingLeft: theme.spacing(2) }}>
        <ProgressIcon style={{ marginTop: theme.spacing(2) }} />
        <CardHeader
          title={'STATUS'}
          titleTypographyProps={{ variant: 'subtitle1' }}
          style={{
            paddingBottom: theme.spacing(1),
            paddingLeft: theme.spacing(1),
          }}
        />
      </Grid>
      <CardContent
        style={{
          paddingTop: theme.spacing(0),
          paddingBottom: theme.spacing(1),
        }}
      >
        <MemberCodeStatusStepper />
        <Box
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            {memberCodeDetails?.status === 'SENT' && memberCodeDetails?.expirationDate && (
              <>
                <Typography variant={'body1'} style={{ fontWeight: 600, marginTop: theme.spacing(3) }}>
                  Code valid until
                </Typography>
                <Typography variant={'caption'}>
                  {moment(memberCodeDetails?.expirationDate).format('DD.MM.YYYY')}
                </Typography>
              </>
            )}
            {/*<Typography variant={ 'body1' } style={ { fontWeight: 600, marginTop: theme.spacing(3) } }>Code valid*/}
            {/*  until</Typography>*/}
            {/*<Typography variant={ 'caption' }>{memberCodeDetails?.expireDate}</Typography>*/}
          </Box>

          <Box
            style={{
              display: 'grid',
              paddingRight: 0,
              marginRight: theme.spacing(2),
            }}
          >
            {memberCodeDetails?.rmName && (
              <>
                <Typography variant={'caption'} style={{ marginTop: theme.spacing(3) }}>
                  Sent by
                </Typography>
                <Typography variant={'body1'} style={{ fontWeight: 600 }}>
                  {memberCodeDetails?.rmName}
                </Typography>
              </>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};
